module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/welcome.f59e68cb.jpg";